var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#606771",
    stroke: "#606771",
    d: "M20.1,236.7L15,219.5c-3.3-11.2-5-22.8-5-34.5c0-64.5,50.8-117,113.3-117c2,0,5.8,0,9.9,0.2V30.6c0-7.8,4.7-11.3,9.3-11.3c2.6,0,5.2,1.1,7.8,3.1l90.3,72.2c3.5,2.8,5.5,6.8,5.5,10.9s-2,8.1-5.5,10.9l-90.3,72.2c-2.6,2.1-5.2,3.1-7.8,3.1c-4.6,0-9.3-3.5-9.3-11.3v-35.6c-4.1-0.1-7.8-0.2-9.9-0.2c-45.3,0-84.7,30.1-98,74.8L20.1,236.7z M123.3,78.8C66.7,78.8,20.7,126.4,20.7,185c0,4.8,0.3,9.5,0.9,14.2C40.4,159.6,79.3,134,123.3,134c3,0,9.5,0.1,15.4,0.4l5.1,0.2v45.5l90-72c1-0.8,1.5-1.7,1.5-2.6c0-0.9-0.5-1.8-1.5-2.5l-90-72v48.3l-5.6-0.2C132.5,78.9,126.2,78.8,123.3,78.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeShareIcon);
export default __webpack_public_path__ + "static/media/youtube-share-icon.9af94be82c991c2a56f94c08977ce5a7.svg";
export { ForwardRef as ReactComponent };